import React from "react";
import { Col } from "react-bootstrap";
import { Controller } from "react-hook-form";
import _ from "lodash";
import { NumericFormat } from "react-number-format";
import { TextField } from "@mui/material";

function MobileViewOperatorOfCaneled({ item, showPrice, typeOfModal, errors, control, setValue, inputList }) {
  function inputOnChange(value, inputType, inputItem, changeInGroup) {
    //// value // مقدار تغییر یافته جدید
    //// inputType  // نوع فایل که تشخیص دهیم کدام ستون است
    //// inputItem // ایتم یا سطر انتخاب شده
    //// changeInGroup // در صورت فعال شدن تنها در گروه خودش اعمال تغییر می کند
    //// isLock // عنوان متغییری که تکست باکس را قفل میکند تا در صورت تغییر هدر تغییر نکند
    const isLock = inputType + "IsLock";
    // ----  ویرایش ایتم  -----
    inputItem[isLock] = true; // قفل کردن ایتم که توسط هدر در اینده تغییر نکند
    inputItem[inputType] = value;
    setValue(inputType + inputItem.id, value);
    // اگر در حال تغییر مبلغ جریمه این ایتم هستیم درصد هم باید تعییر کند
    if (inputType === "fineAmount") {
      inputItem[inputType + "100" + "IsLock"] = true; // قفل کردن ایتم که توسط هدر در اینده تغییر نکند
      inputItem[inputType + "100"] =
        "" + _.toInteger((100 * _.toInteger(value.replaceAll(",", ""))) / inputItem.price);
      setValue(
        inputType + "100" + inputItem.id,
        "" + _.toInteger((100 * _.toInteger(value.replaceAll(",", ""))) / inputItem.price),
      );
    } // و برعکس
    if (inputType === "fineAmount100") {
      inputItem["fineAmountIsLock"] = true; // قفل کردن ایتم که توسط هدر در اینده تغییر نکند
      inputItem["fineAmount"] = "" + _.toInteger((inputItem.price * _.toInteger(value.replaceAll("درصد", ""))) / 100);
      setValue(
        "fineAmount" + inputItem.id,
        "" + _.toInteger((inputItem.price * _.toInteger(value.replaceAll("درصد", ""))) / 100),
      );
    }
    // ایا ایتم در اول گروه قرار دارد ؟ تغییر بقیه ایتم ها
    let changeItemList = [];
    if (inputList.length > 0) {
      if (changeInGroup) {
        // اعمال تغییر در گروه خودش تنها صورت پذیرد اگر در ابتدای لیست
        let currentGroupList = inputList.filter(function (item) {
          return item.basketItemId == inputItem.basketItemId;
        });
        if (currentGroupList.length > 0 && currentGroupList[0].id == inputItem.id) changeItemList = currentGroupList;
      } else {
        // اعمال تغییر در تمام لیست صورت پذیرد اگر در ابتدای لیست
        if (inputList[0].id == inputItem.id) changeItemList = inputList;
      }
    }
    // تغییر ایتم های دیگر مجموعه
    if (changeItemList.length > 0) {
      changeItemList.map((item) => {
        if (!item[isLock]) {
          item[inputType] = value;
          setValue(inputType + item.id, value);
          // اگر در حال تغییر مبلغ جریمه این ایتم هستیم درصد هم باید تغییر کند
          if (inputType === "fineAmount") {
            item["fineAmount100"] = "" + _.toInteger((100 * _.toInteger(value.replaceAll(",", ""))) / item.price);
            setValue(
              "fineAmount100" + item.id,
              "" + _.toInteger((100 * _.toInteger(value.replaceAll(",", ""))) / item.price),
            );
          } // و برعکس
          if (inputType === "fineAmount100") {
            item["fineAmount"] = "" + _.toInteger((item.price * _.toInteger(value.replaceAll("درصد", ""))) / 100);
            setValue(
              "fineAmount" + item.id,
              "" + _.toInteger((item.price * _.toInteger(value.replaceAll("درصد", ""))) / 100),
            );
          }
        }
      });
    }
  }

  return (
    <>
      <Col className="px-2">
        <Col className="d-flex justify-content-end my-2" lg="6">
          {item && item.personFullName}
        </Col>
        <Col className="d-flex justify-content-end my-2">{item.cancelStatusS}</Col>
        <Col className="d-flex justify-content-end my-2">{`${showPrice.format(item.price)}تومان`}</Col>
        <Col className="d-flex justify-content-end my-2">{`${showPrice.format(item.paymentAmount)}تومان`}</Col>
        <Col className="d-flex justify-content-end my-2">{`${showPrice.format(item.payToWarantyAmount)}تومان`}</Col>
        <Col className="d-flex justify-content-end my-2">{`${showPrice.format(item.receiveOfWarantyAmount)}تومان`}</Col>
        <Col className="d-flex justify-content-end my-2 px-0">
          <Controller
            name={"fineAmount" + item.id}
            control={control}
            rules={{ required: typeOfModal === "CancelStatus" ? false : true }}
            render={({ field: { value } }) => (
              <NumericFormat
                customInput={TextField}
                name={"fineAmount" + item.id}
                size="small"
                value={value || ""}
                className={
                  errors["fineAmount" + item.id]
                    ? "border border-danger form-control text-center"
                    : "text-center form-control"
                }
                onKeyDown={(e) => {
                  if (e.key === "Escape") {
                    e.stopPropagation()
                  }
                }}
                type="search"
                variant="outlined"
                thousandSeparator=","
                decimalScale="."
                onChange={(event) => inputOnChange(event.target.value, "fineAmount", item, true)}
                placeholder=" مبلغ جریمه "
              />
            )}
          />
        </Col>
        <Col className="d-flex justify-content-end my-2 px-0">
          <Controller
            name={"fineAmount100" + item.id}
            control={control}
            render={({ field: { value } }) => (
              <NumericFormat
                customInput={TextField}
                name={"fineAmount100" + item.id}
                size="small"
                value={value || ""}
                className="text-center form-control"
                variant="outlined"
                decimalScale="."
                type="search"
                suffix=" درصد  "
                onChange={(event) => inputOnChange(event.target.value, "fineAmount100", item, true)}
                placeholder=" درصد جریمه "
                onKeyDown={(e) => {
                  if (e.key === "Escape") {
                    e.stopPropagation()
                  }
                }}
              />
            )}
          />
        </Col>
      </Col>
    </>
  );
}

export default MobileViewOperatorOfCaneled;
